import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const Report2CAExportRequest = (values, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RanReportKpis/GenerateAcceptance2CAReport`,
	data: { values, userId }
});
